mutation GenerateSalesforceCasesForAccountPerformance(
  $accountPerformanceId: ID!
) {
  generateSalesforceCasesForAccountPerformance(
    input: { accountPerformanceId: $accountPerformanceId }
  ) {
    success
  }
}
